import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class LightingInstructionService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<LightingInstruction[]> => {
    return this.apiHttp.get<LightingInstruction[]>("lightinginstructions");
  };

  public get = (id: number): Observable<LightingInstruction> => {
    return this.apiHttp.get<LightingInstruction>(`lightinginstructions/${id}`);
  };
}

export interface LightingInstruction {
  id: number;
  name: string;
  isActive: boolean;
  requiresFollowup: boolean;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/lighting-instruction.service.ts